// @packages
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';

// @scripts
import CtrlEditCandidateItem from './edit-candidate-item';
import CtrlIgGrid from '../ctrl-ig-grid';
import { CATEGORY } from '../../../../helpers/searchInput';
import { columns, fields } from './config';
import { environment, globalUI } from '../../../../core';
import { newGuid } from '../../../../helpers';

// @styles
import styles from './styles';

const CtrlCandidateGrid = ({
    category,
    className,
    classes,
    dataSource,
    id,
    onAddItemToSchedule,
    primaryKey,
    visible
}) => {
    if (!visible) {
        return null;
    }
    let gridColumns = columns;
    if (category !== "windDriven") {
        gridColumns = gridColumns.filter(a => a.key !== 'lowWeather' && a.key !== 'highWeather');
    }

    const handleOnRowSelected = (itemId, buttonOffsetTop) => {
        const item = dataSource.find((item) => item[primaryKey] === itemId);
        const editForm = (
            <CtrlEditCandidateItem
                fields={fields}
                id={id}
                item={item}
            />
        );
        const onConfirm = () => {
            const scheduleItem = {
                ...item,
                category,
                id: newGuid()
            };
            let maxexhaust = scheduleItem.maxExhVelFPM;
            if(scheduleItem)
            {
                if(scheduleItem.selectedFlowDirection === "I" || maxexhaust === 0)                
                    scheduleItem.maxExhVelFPM = 0;
                else
                scheduleItem.maxExhVelFPM = maxexhaust;
            }
            onAddItemToSchedule(scheduleItem);
        };

        globalUI.showModalDialog({
            msg: editForm,
            onConfirm,
            style: environment.isProduction && environment.isFromSelNav ? { top: buttonOffsetTop } : null,
            title: `Add Candidate '${item[primaryKey]}' to Schedule`
        });
    };

    const candidateGridClass = classNames(
        className,
        classes.candidateGrid
    );

    return (
        <CtrlIgGrid
            className={candidateGridClass}
            columns={gridColumns}
            dataSource={dataSource}
            enableFilter
            enableGroup
            enableHiding
            enableHotkeys
            enableMergeCells
            enableMoveColumn
            enableMultiColumHeader
            enableMultipleRowSelection
            enableResize
            enableRowIndex
            enableSelectRow
            enableSort
            enableTooltip
            fixedHeaders
            id={`${id}-grid`}
            height='550'
            onSelectRow={handleOnRowSelected}
            primaryKey={primaryKey}
        />
    );
};

CtrlCandidateGrid.propTypes = {
    category: PropTypes.oneOf([...Object.values(CATEGORY)]).isRequired,
    className: PropTypes.string,
    classes: PropTypes.object.isRequired,
    dataSource: PropTypes.array.isRequired,
    id: PropTypes.string.isRequired,
    onAddItemToSchedule: PropTypes.func.isRequired,
    primaryKey: PropTypes.string,
    visible: PropTypes.bool
};

CtrlCandidateGrid.defaultProps = {
    className: null,
    primaryKey: 'model',
    visible: true
};

export default withStyles(styles)(CtrlCandidateGrid);
